export const REQUIREMENT_TYPE = {
  LIST: "list",
  TEXT: "text",
  WEIGHTED_OPTION: "weighted-options"
};

export const DELIVERY_METHOD = {
  WHATSAPP_FORM: "whatsapp_form",
  CHATBOT: "chatbot"
};

export const IMPORTANCE_OPTIONS = (t) => [
  { label: t("Irrelevant"), value: "not", isShaded: true },
  { label: t("Not important"), value: "unwichtig" },
  { label: t("Important"), value: "wichtig" },
  { label: t("Very important"), value: "sehrWichtig" },
  { label: t("Required"), value: "voraussetzung", isShaded: true }
];

export const LANGUAGE_WEIGHT_OPTIONS = (t) => [
  { label: `A1 (${t("Beginner")})`, value: "A1" },
  { label: `A2 (${t("Basic knowledge")})`, value: "A2" },
  { label: `B1 (${t("Intermediate")})`, value: "B1" },
  { label: `B2 (${t("Upper-Intermediate")})`, value: "B2" },
  { label: `C1 (${t("Expert")})`, value: "C1" },
  { label: `C2 (${t("Native")})`, value: "C2" }
];

export const LANGUAGE_LEVELS = {
  A1: 1,
  A2: 2,
  B1: 3,
  B2: 4,
  C1: 5,
  C2: 6
};

export const LANGUAGE_LEVELS_REVERSED = {
  0: "A1",
  1: "A2",
  2: "B1",
  3: "B2",
  4: "C1",
  5: "C2"
};
